module.exports = __webpack_public_path__ + "static/media/leuli.b64674bb.png";